import {
    Box,
    chakra,
    Flex,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { BsTrophy } from 'react-icons/bs';
  import { BsPerson } from 'react-icons/bs';
  import { FiServer } from 'react-icons/fi';
  import { GoLocation } from 'react-icons/go';
  
  function StatsCard(props) {
    const { title, stat, icon, color1, color2 } = props;
    return (
      <Stat
        px={{ base: 2, md: 4 }}
        py={'5'}
        shadow={'xl'}
        border={'1px solid'}
        borderColor={useColorModeValue(color1, color2)}
        rounded={'lg'}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Box pl={{ base: 2, md: 4 }}>
            <StatLabel fontWeight={'medium'} >
              {title}
            </StatLabel>
            <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
              {stat}
            </StatNumber>
          </Box>
          <Box
            my={'auto'}
            color={useColorModeValue(color1, color2)}
            alignContent={'center'}>
            {icon}
          </Box>
        </Flex>
      </Stat>
    );
  }
  
  export default function Facts() {
    return (
      <Box maxW="7xl" mx={'auto'} my={20} pt={5} px={{ base: 2, sm: 12, md: 17 }}>
        <chakra.h1
          textAlign={'center'}
          fontSize={'4xl'}
          py={10}
          fontWeight={'bold'}>
          Some Last Year Facts,
        </chakra.h1>
        <SimpleGrid columns={{ base: 1, md: 4, sm:2 }} spacing={{ base: 5, lg: 8 }}>
          <StatsCard
            title={'IN PRIZE TO BE WON'}
            stat={'650+'}
            icon={<BsTrophy size={'3em'} />}
            color1={'orange.500'}
            color2={'orange.200'}
            />
          <StatsCard
            title={'PARTICIPANTS'}
            stat={'3,589+'}
            icon={<BsPerson size={'3em'} />}
            color1={'orange.600'}
            color2={'orange.200'}
            />
          <StatsCard
            title={'EVENTS'}
            stat={'80+'}
            icon={<GoLocation size={'3em'} />}
            color1={'green.600'}
            color2={'green.200'}
            />
          <StatsCard
            title={'FOOTFALL'}
            stat={'7500'}
            icon={<FiServer size={'3em'} />}
            color1={'green.500'}
            color2={'green.200'}
          />
        </SimpleGrid>
      </Box>
    );
  }